module.exports = __webpack_public_path__ + "static/img/11.05598ca5.png";